// extracted by mini-css-extract-plugin
export default {"button":"Button_button__U2e+c","disabled":"Button_disabled__XJLAf"};